import { fromJS, List, Map } from 'immutable'
import { getUserPortalDataByUuid } from '../../user/portal'
import * as ACTIONS from './actions'

const log = console

async function getPmPortalsHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  const lists = payload
  const portalLists = fromJS(lists.filter((list) => list.type === 'portals'))
  const uuids = portalLists.reduce((acc, list) => {
    const listItems = list.get('listItems', List())
    const uuidsInList = listItems.map((item) => item.get('uuid'))
    return acc.push(...uuidsInList)
  }, List()).toSet()
  try {
    store.dispatch(ACTIONS.setPmPortalsProcessing())
    const portals = await Promise.all(
      uuids.map(async (uuid) => getUserPortalDataByUuid({ auth, server: config.getIn(['data', 'servers', 'brooklyn']), uuid })),
    )
    const keyed = fromJS(portals).reduce((acc, portal) => {
      const returnVal = acc.set(portal.get('uuid'), portal)
      return returnVal
    }, Map())
    store.dispatch(ACTIONS.setPmPortals({ portals: keyed }))
  } catch (error) {
    log.error(error, 'Error getting portals')
    store.dispatch(ACTIONS.setPmPortalsError({
      error,
    }))
  }
}

export default (store) => (next) => (action) => {
  const { type, payload } = action
  switch (type) {
    case ACTIONS.PM_PORTALS_GET:
      getPmPortalsHandler({ store, payload })
      break
    default:
      break
  }
  next(action)
}
